export const sortAuthTokens = tokensRaw => {
    return tokensRaw.reduce(
        (acc, token, i) => {
            const { id, service } = token
            const sortToUse =
                service === "system"
                    ? "systemAccessTokensSort"
                    : "outsideAccessTokensSort"

            return {
                ...acc,
                items: { ...acc.items, [id]: token },
                sort: [...acc.sort, id],
                [sortToUse]: [...acc[sortToUse], id],
            }
        },
        {
            items: {},
            sort: [],
            outsideAccessTokensSort: [],
            systemAccessTokensSort: [],
        },
    )
}

export const getSystemAccessTokens = tokens => {
    const { systemAccessTokensSort, items } = tokens
    const accessTokenItems = systemAccessTokensSort.map(tokenId => {
        return { ...items[tokenId] }
    })

    return accessTokenItems
}

export const createOAuthPopupWindow = () => {
    // define params for popup window
    const w = 650
    const h = 600
    const dualScreenLeft =
        window.screenLeft != undefined ? window.screenLeft : window.screenX
    const dualScreenTop =
        window.screenTop != undefined ? window.screenTop : window.screenY
    const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : screen.width
    const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : screen.height

    const left = width / 2 - w / 2 + dualScreenLeft
    const top = height / 2 - h / 2 + dualScreenTop

    // create popup window
    const child = window.open(
        "",
        null,
        `
         height=${h},
         width=${w},
         status=yes,
         toolbar=no,
         menubar=no,
         location=no,
         titlebar=no,
         left=${left},
         top=${top}
     `,
    )
    return child
}



// WEBPACK FOOTER //
// ./src/util/oauth_utils.js